import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { StaticSitesDto } from '../../models/static-sites-dto';

export class StaticSitesListApi {
    constructor(protected baseUrl: string) {}

    public getStaticSites(searchParams: URLSearchParams): Promise<ApiResult<PaginatedResponse<StaticSitesDto>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/static-sites`, { params: searchParams }),
            response => response.data
        );
    }
}
